import { UploadFileDataComponent } from './upload-file-data/upload-file-data.popup';

export const popups = [
  UploadFileDataComponent,
];

export * from './upload-file-data/upload-file-data.popup';
